import { useEffect } from "react"
import { _AccountHelpDesk, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { AccountEditor } from "../editor/AccountEditor"
import { BasicPage } from "../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../theme/Component/BasicTable"
import useModal, { MODAL_md, MODAL_SM } from "../theme/Component/hooks/useModal"
import { ListMenu } from "../theme/Component/ListMenu"
import { Modal } from "../theme/Component/Modal"
import { ModalConfirm } from "../theme/Component/ModalConfirm"

export const AccountHelpDesk = () => {

    const _accountHelpDesk = useDataBean(_AccountHelpDesk);
    const {bean,setBean,lista,setLista,handleChange} = _accountHelpDesk;
    const modal = useModal("Concepto",MODAL_md);
    const modalDel = useModal("Eliminar",MODAL_SM);

    useEffect(()=>{
        getAccountHelpDeskRender();
    },[])

    const head = [
        { title: 'ID', property: 'IDAccountHelpDesk', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripcion', property: 'Description', visible: true },
        { title: 'Funcionario', property: 'AccountFullName', visible: true }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-edit-line', visible: _single.canEdit(), evento: () => { modal.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getAccountHelpDeskRender=()=>{
        _accountHelpDesk.instance.getAccountHelpDeskRender(1,15,{State:1}).then(
            (resp:any)=>{
                setLista(resp.List);
            }
        )
    }

    const updateItem = ()=>{
        _accountHelpDesk.updateCustonBean(bean).then(
            (resp:any)=>{
                getAccountHelpDeskRender();
                modal.close();
            }
        )
    }
    
    const agregarItem =()=>{
        setBean({
            State:_accountHelpDesk.instance.ACTIVE,
            IDEmployee:_single.getAccountID()
        });
        modal.open();
    }

    const eliminar=()=>{
        _accountHelpDesk.deleteItem(bean.IDAccountHelpDesk).then(
            (resp:any)=>{
                getAccountHelpDeskRender();
                modalDel.close();
            }
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]
    return (
        <BasicPage titulo="Conceptos Flujo">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={updateItem} onSubmitLabel="Actualizar">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre Concepto</label>
                                <input className="form-control" type="text" name="Name" id="Name" value={bean.Name} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor label="Funcionario" idAccount={bean.IDAccount} onChange={(e)=>{setBean({...bean,"IDAccount":e.IDAccount})}}/>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" name="Description" id="Description" value={bean.Description} onChange={handleChange}></textarea>
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={eliminar}>
                        Eliminar item
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}